// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__dNJej","searchInput":"SearchInput_searchInput__zLKVB"};